export enum UnitOfMeasurementSystemNameEnum {
  CUBIC_METERS = "Cubic Meters",
  KILOGRAMS = "Kilograms",
  SQUARE_METERS = "Square Meters",
  METERS = "Meters",
  UNITS = "Units",
}
